import { createStore } from "../../utils/createStore.ts";

export const versionBannerStore = createStore(
  {
    showVersionBanner: false,
  },
  ({ set }) => ({
    openShowVersionBanner: () =>
      set({
        showVersionBanner: true,
      }),
    closeShowVersionBanner: () => set({ showVersionBanner: false }),
  }),
);
